import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled from '@emotion/styled';
import { CarouselStyled } from '@nike/nike-design-system-components';
import Imagetext from '../Imagetext/Imagetext';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SliderDiv = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  ul { padding-left: 0px !important; overflow: hidden; margin: 0; }\n  li:first-child { padding-left: 0px !important; }\n  .nds-carousel { height: 100%; }\n  ul.slider { height: 100%; overflow-x: hidden; }\n  li.slide { height: 100%; }\n  .nds-image-wrapper { height: 100%; }\n  .nds-content-card { height: 100%; }\n  .nds-aspect-ratio-box { height: 100%; }\n"])));
var Slider = function Slider(props) {
  var placement = props.placement,
    mediaHost = props.mediaHost,
    linkHost = props.linkHost,
    slides = props.slides,
    transitionTime = props.transitionTime;
  return /*#__PURE__*/_jsx(SliderDiv, {
    children: /*#__PURE__*/_jsx(CarouselStyled, {
      autoPlaySpeed: transitionTime,
      navigationMode: "autoPlay",
      showPeek: {
        xs: false
      },
      childContentFocusable: true,
      columnGap: "0px",
      conditionallyHideNavButtons: true,
      slidesToShow: {
        xs: 1,
        m: 1
      },
      title: "",
      children: slides.map(function (slide) {
        return /*#__PURE__*/_createElement(Imagetext, _objectSpread(_objectSpread({}, slide), {}, {
          linkHost: linkHost,
          mediaHost: mediaHost,
          key: "".concat(slide.root.image.fileReference, "_").concat(slide.xfPath),
          placement: placement,
          defaultImageWidth: "1920",
          defaultImageLength: "820"
        }));
      })
    })
  });
};
export default Slider;